import { isDev, isProd, urlIncludeDomain } from "@/utils/tools.js";
import { baseUrl } from '@/config/apiConfig.js';

import { isMobileDevice, murekaAppPlantfrom } from "@/utils/tools.js"


export const chinaAppName = "MurekaCn"  //"MurekaCn";
export const overseasAppName = "Mureka";

const originRootUrl = import.meta.env.VITE_APPNAME == chinaAppName ? isDev() ? "https://test.mureka.cn" : "https://www.mureka.cn" : isDev() ? "https://test.mureka.ai" : "https://www.mureka.ai";

const globalConfig = {
  appname: import.meta.env.VITE_APPNAME, // "Mureka", MurekaCn
  platform: isMobileDevice() ? 'h5' : 'web',
  MAX_LYRIC_COUNT: 3000,
  curObjectStorageType: "OSS", // OSS || COS
  version: "1.0.1",
  localStorageGlobalKey: `${import.meta.env.VITE_APPNAME}_ai_globaldata`,
  curObjectStorageExpirTimeForwardTo: 30 * 1000, //mm
  baseObjectStorageUrl: import.meta.env.VITE_COS_BASE_URL,
  baseAssetsUrl:
    import.meta.env.VITE_PUBLIC_PATH == "" || import.meta.env.VITE_PUBLIC_PATH == "/"
      ? originRootUrl
      : import.meta.env.VITE_PUBLIC_PATH,
  baseOrigin: originRootUrl, // import.meta.env.VITE_APP_BASE_ORIGIN,

  switchLanguage: import.meta.env.VITE_SWITCH_LANGUAGE === "true",
  murekaAppPlantfrom: murekaAppPlantfrom(),
  stripeKey: import.meta.env.VITE_STRIPE_KEY ?? '',
  abtestUrl: import.meta.env.VITE_ABTEST_URL ?? '',
  paypalConsoleUrl: import.meta.env.VITE_PAYPAL_CONSOLE_URL ?? '',
  paypalKey: import.meta.env.VITE_PAYPAL_KEY ?? ''
};


export const getGuidanceJsonDataUrl = () => {
  // return globalConfig.appname == chinaAppName
  //   ? isProd()
  //     ? "cos-prod/res/default/yinfeng.json"
  //     : "cos-test/res/default/yinfeng.json"
  //   : isProd()
  //     ? "cos-prod/res/default/mureka.json"
  //     : "cos-test/res/default/mureka.json";
  return isProd()
    ? "cos-prod/res/default/mureka.json"
    : "cos-test/res/default/mureka.json";
};

export default globalConfig;



export const linkMap = {
  waitingList: "www.baidu.com",
  youtube: "https://www.youtube.com/@Melodioai",
  twitter: "https://x.com/Melodioai",
  Discord: "https://discord.gg/aSGcjSYB8A",
  termsofservice:
    "https://plausible-nape-c6d.notion.site/Terms-of-Service-794a545bc9f24996a90bca2801aab8df?pvs=4",
  privacypolicy:
    "https://plausible-nape-c6d.notion.site/Privacy-Policy-eb0e6079c3c34b0c9e5b3eaceb4ae8d8?pvs=4",
};

export const openLink = (link, _isBlank) => {
  window.open(link, _isBlank);
};



export const getStaticFullUrl = (url) => {
  if (urlIncludeDomain(url)) {
    return url;
  }
  return originRootUrl + url;
}


// 功能模块开关， 多语言开关在环境变量里面
export const ModuleOpenStateControl = {
  create: {
    release: false, //  是否开启发布
    generatingStream: () => {
      const appContext = window.vueApp?.appContext;
      return appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.isAudioReadableStreamSupported();
    }, // 是否支持流式生成和播放
    syncPlayWhenGenerated: true, // 是否在生成时同步播放替换伪流式播放为mp3并同步播放路径
    vocalCustom: true, // 是否开启人声定制
    motifReferCustom: true, // 是否开启motif（melody ideas）定制
    motifReferCustomMidi: true, // 是否开启motif（melody ideas）midi选项
    vacalCustomNewCornerMarkEndTime: "2025-01-15 23:59:59",
    generateStepProgress: globalConfig.appname != chinaAppName, // 是否开启生成步骤
    generateStepProgressMenu: false, // 是否开启生成步骤菜单
    feedback: true, // 是否开启反馈
    lyricsOptimize: true, // 是否开启歌词优化，

  },
  home: {
    similar: true // 是否开启相似歌曲推荐
  },
  createVideo: {
    opened: true, // 是否开启视频生成
    endTime: "2025-12-31 23:59:59", // 视频生成结束时间
  },
  editor: {
    opened: true, // 是否开启编辑器
    regionEditing: true, // 是否开启区域编辑
    extendEditing: true, // 是否开启扩展编辑
    trackStem: isDev(), // 是否开启轨道编辑
    coverVoice: isDev(), // 是否开启人声遮罩
    lyricsTranslate: isDev(), // 是否开启歌词翻译
    trimEditing: true, // 是否开启裁剪编辑
    editorRegionEditing: true, // 是否开启编辑器区域编辑
    editorExtendEditing: true, // 是否开启编辑器扩展编辑
    editorTrackStem: true, // 是否开启编辑器轨道编辑
    editorCoverVoice: isDev(), // 是否开启编辑器人声遮罩
    editorLyricsTranslate: isDev(), // 是否开启编辑器歌词翻译
    editorTrimEditing: true, // 是否开启编辑器裁剪编辑
    regionEditingBeta: true, // 是否开启区域编辑beta
    extendEditingBeta: true, // 是否开启扩展编辑beta
    trackStemBeta: true, // 是否开启轨道编辑beta
    coverVoiceBeta: true, // 是否开启人声遮罩beta
    lyricsTranslateBeta: true, // 是否开启歌词翻译beta
    trimEditingBeta: false, // 是否开启裁剪编辑beta
    extendMaxDurationLimitModel: [] //['V7', 'V6', 'V5', "O1", null, '', undefined], // 扩展编辑最大时长限制模型
  },
  model: {
    opened: true, // 是否开启模型选择
    custom: true// 是否开启模型定制,
  },
  speControl: {
    linkCrawling: true,// globalConfig.appname != chinaAppName, // 是否开启链接爬取
    motifReferMidiPlay: isDev(), // 是否开启motif midi播放
    feedback: true, // 是否开启反馈
  },
  pay: {
    openMobile: true
  }
}

export const getPipeReadableFlowUrl = (stremKey) => {
  return `${baseUrl}/api/live/pipe/audio?stream_key=${stremKey}`;
}

export const updateGlobalConfig = (config) => {
  Object.assign(globalConfig, config);
}



// export const updateModuleOpenStateControlItem = (keyField, value) => {
//   const keyFields = keyField.split(".");
//   let curConfig = ModuleOpenStateControl;
//   for (let i = 0; i < keyFields.length - 1; i++) {
//     curConfig = curConfig[keyFields[i]];
//     if (!curConfig) {
//       return;
//     }
//   }
//   curConfig[keyFields[keyFields.length - 1]] = value;
// }